module.exports = __webpack_public_path__ + "lui-icons.woff";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=lui-icons.woff!./src/resources/lui-icons.woff
// module id = 113
// module chunks = 0